import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const SettingsBar = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 25 25">
    {/*#356482*/}
    <path
      d="M4.2739 3.26624H0.588229C0.263319 3.26624 0 3.00408 0 2.68097C0 2.35787 0.263319 2.0957 0.588229 2.0957H4.2739C4.59881 2.0957 4.86213 2.35787 4.86213 2.68097C4.86213 3.00408 4.59881 3.26624 4.2739 3.26624Z"
      fill={props.stroke}
    />
    <path
      d="M6.38189 5.36171C4.89616 5.36171 3.6875 4.15913 3.6875 2.68101C3.6875 1.20258 4.89616 0 6.38189 0C7.86761 0 9.07627 1.20258 9.07627 2.68101C9.07627 4.15918 7.86761 5.36171 6.38189 5.36171ZM6.38189 1.17058C5.54488 1.17058 4.86396 1.84821 4.86396 2.68101C4.86396 3.5138 5.54488 4.19113 6.38189 4.19113C7.21889 4.19113 7.89981 3.5138 7.89981 2.68101C7.89981 1.84821 7.21889 1.17058 6.38189 1.17058Z"
      fill={props.stroke}
    />
    <path
      d="M19.4112 3.26624H10.6195C10.2946 3.26624 10.0312 3.00408 10.0312 2.68097C10.0312 2.35787 10.2946 2.0957 10.6195 2.0957H19.4111C19.736 2.0957 19.9993 2.35787 19.9993 2.68097C19.9993 3.00408 19.7361 3.26624 19.4112 3.26624Z"
      fill={props.stroke}
    />
    <path
      d="M14.2764 12.4342C12.7906 12.4342 11.582 11.2316 11.582 9.75346C11.582 8.27533 12.7907 7.07275 14.2764 7.07275C15.7621 7.07275 16.9708 8.27533 16.9708 9.75346C16.9708 11.2316 15.7622 12.4342 14.2764 12.4342ZM14.2764 8.24334C13.4394 8.24334 12.7585 8.92066 12.7585 9.75346C12.7585 10.5863 13.4394 11.2636 14.2764 11.2636C15.1134 11.2636 15.7943 10.5863 15.7943 9.75346C15.7943 8.92066 15.1134 8.24334 14.2764 8.24334Z"
      fill={props.stroke}
    />
    <path
      d="M10.0381 10.3385H0.588229C0.263319 10.3385 0 10.0763 0 9.75324C0 9.43014 0.263319 9.16797 0.588229 9.16797H10.0381C10.363 9.16797 10.6264 9.43014 10.6264 9.75324C10.6264 10.0763 10.363 10.3385 10.0381 10.3385Z"
      fill={props.stroke}
    />
    <path
      d="M19.4127 10.3385H16.3851C16.0602 10.3385 15.7969 10.0763 15.7969 9.75324C15.7969 9.43014 16.0602 9.16797 16.3851 9.16797H19.4127C19.7376 9.16797 20.0009 9.43014 20.0009 9.75324C20.0009 10.0763 19.7376 10.3385 19.4127 10.3385Z"
      fill={props.stroke}
    />
    <path
      d="M5.72173 19.5067C4.236 19.5067 3.02734 18.3042 3.02734 16.8257C3.02734 15.3476 4.236 14.145 5.72173 14.145C7.20746 14.145 8.41611 15.3476 8.41611 16.8257C8.41611 18.3042 7.20746 19.5067 5.72173 19.5067ZM5.72173 15.3156C4.88472 15.3156 4.2038 15.9929 4.2038 16.8257C4.2038 17.6585 4.88472 18.3361 5.72173 18.3361C6.55873 18.3361 7.23966 17.6585 7.23966 16.8257C7.23966 15.9929 6.55873 15.3156 5.72173 15.3156Z"
      fill={props.stroke}
    />
    <path
      d="M19.4131 17.4113H9.96323C9.63832 17.4113 9.375 17.1491 9.375 16.826C9.375 16.5029 9.63832 16.2407 9.96323 16.2407H19.4131C19.738 16.2407 20.0014 16.5029 20.0014 16.826C20.0014 17.1491 19.738 17.4113 19.4131 17.4113Z"
      fill={props.stroke}
    />
    <path
      d="M3.6158 17.4113H0.588229C0.263319 17.4113 0 17.1491 0 16.826C0 16.5029 0.263319 16.2407 0.588229 16.2407H3.6158C3.94071 16.2407 4.20403 16.5029 4.20403 16.826C4.20403 17.1491 3.94071 17.4113 3.6158 17.4113Z"
      fill={props.stroke}
    />
  </SvgIcon>
);
